import { render, staticRenderFns } from "./MemberStatus.vue?vue&type=template&id=bb578684&scoped=true&"
import script from "./MemberStatus.vue?vue&type=script&lang=js&"
export * from "./MemberStatus.vue?vue&type=script&lang=js&"
import style0 from "./MemberStatus.vue?vue&type=style&index=0&id=bb578684&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb578684",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
